import { fuelfilterConditionService } from '../../helpers/services/fuelfilterCondition.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const FUEL_FILTER_CONDITION_MODULE = 'fuelfilterCondition'; 

// define action 
export const GET_ALL_FUEL_FILTER_CONDITIONS = 'getAllfuelfilterConditions';
export const GET_FUEL_FILTER_CONDITION = 'getfuelfilterCondition';
export const UPDATE_FUEL_FILTER_CONDITION = 'updatefuelfilterCondition';
export const CREATE_FUEL_FILTER_CONDITION = 'createfuelfilterCondition';
export const UPDATE_FUEL_FILTER_CONDITION_STATUS = 'updatefuelfilterConditionStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_FUEL_FILTER_CONDITIONS_REQUEST = "getAllfuelfilterConditions";
const GET_FUEL_FILTER_CONDITION_REQUEST = "getfuelfilterCondition";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_FUEL_FILTER_CONDITIONS]({ commit }, { filter }) {
        fuelfilterConditionService
            .getAllfuelfilterConditions(filter)
            .then(
                (result) => {
                    commit(GET_ALL_FUEL_FILTER_CONDITIONS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_FUEL_FILTER_CONDITION]({ commit }, { id }) {
        fuelfilterConditionService
            .getfuelfilterCondition(id)
            .then(
                (result) => {
                    commit(GET_FUEL_FILTER_CONDITION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_FUEL_FILTER_CONDITION]({ commit }, { data }) {
        commit(REQUEST)
        fuelfilterConditionService
            .updatefuelfilterCondition(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.fuelfilterCondition')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_FUEL_FILTER_CONDITION]({ commit }, { data }) {
        commit(REQUEST)
        fuelfilterConditionService
            .createfuelfilterCondition(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.fuelfilterCondition')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_FUEL_FILTER_CONDITION_STATUS]({ dispatch }, { filter, data }) {
        fuelfilterConditionService
            .updatefuelfilterConditionStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_FUEL_FILTER_CONDITIONS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Fuel-filter-condition-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_FUEL_FILTER_CONDITIONS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_FUEL_FILTER_CONDITION_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


